export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "platform-guide",
    name: "平台入门",
    description: "新手快速上手凪光在线，了解平台基础功能与操作流程",
    icon: "ri-guide-line",
    articleCount: 6,
  },
  {
    slug: "usage-tips",
    name: "使用技巧",
    description: "高效使用凪光在线的进阶技巧与实用方法",
    icon: "ri-lightbulb-line",
    articleCount: 8,
  },
  {
    slug: "security-guide",
    name: "安全指南",
    description: "保障账户安全、数据隐私与平台使用安全的最佳实践",
    icon: "ri-shield-check-line",
    articleCount: 5,
  },
  {
    slug: "latest-news",
    name: "最新动态",
    description: "凪光在线平台更新、功能升级与行业资讯",
    icon: "ri-flashlight-line",
    articleCount: 7,
  },
  {
    slug: "faq-common",
    name: "常见问题",
    description: "用户最常遇到的疑问与详细解答汇总",
    icon: "ri-question-answer-line",
    articleCount: 10,
  },
];